/**
 * @generated SignedSource<<fc041fab258af7d07c93db27fa8e550d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompletedTransaction_charge$data = {
  readonly transactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly endToEndId: string | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly " $fragmentType": "PaymentLinkCompletedTransaction_charge";
};
export type PaymentLinkCompletedTransaction_charge$key = {
  readonly " $data"?: PaymentLinkCompletedTransaction_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompletedTransaction_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompletedTransaction_charge",
  "selections": [
    {
      "alias": "transactions",
      "args": null,
      "concreteType": "PixTransactionConnection",
      "kind": "LinkedField",
      "name": "pixTransactions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PixTransactionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PixTransaction",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endToEndId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "e783d778e81cbed13decc379ca5446e5";

export default node;
